export const prefixesWithOutSubscription = [];
